import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { parseTime } from 'src/app/helpers/date-time';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { StorePromotionModel } from 'src/app/models/promotions/store-promotion.model';
import { StoreModel } from 'src/app/models/store/store.model';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';
import { BasePagedPage } from '../../pages/base-paged-page';
import { UserPromotionModel } from 'src/app/models/promotions/user-promotion.model';

@Component({
    selector: 'app-user-promotions',
    templateUrl: './user-promotions.component.html',
    styleUrls: ['./user-promotions.component.scss'],
    standalone: false
})
export class UserPromotionsComponent extends BasePagedPage<any, FormGroup> {

  public newPromotionForm = new FormGroup({
    name: new FormControl<string | undefined>(undefined, Validators.required),
    image: new FormControl<string | undefined>(undefined, Validators.required),
    isEnabled: new FormControl<boolean>(true),
    startDateUTC: new FormControl<NgbTimeStruct | undefined>(undefined),
    endDateUTC: new FormControl<NgbTimeStruct | undefined>(undefined),
    promoCode: new FormControl<string | undefined>(undefined, Validators.required)
  });

  public currentFormGroup?: FormGroup;

  private mUserId?: string;

  @Input()
  public set userId(value: string | undefined) {
    if (value && this.mUserId != value) {
      this.mUserId = value;
      this.getData(1);
    }
  }

  public get userId(): string | undefined {
    return this.mUserId;
  }



  public constructor(private mApiService: ApiService,
    private mMessageService: MessageService,) {
    super();
  }

  public addNew() {
    this.isBusy = true;
    this.mApiService.post<StorePromotionModel, StorePromotionModel>(`/api/admin/promotion/user/${this.userId}`, this.newPromotionForm.value as StorePromotionModel).subscribe({
      next: () => {
        this.isBusy = false;
        this.getData(1);
        this.mMessageService.addMessage({ text: 'Акция добавлена', type: this.mMessageService.types.success });
        this.newPromotionForm.patchValue({
          name: undefined,
          promoCode: undefined,
          image: undefined,
          isEnabled: true,
          endDateUTC: undefined,
          startDateUTC: undefined
        })
      },
      error: () => this.isBusy = false
    })
  }

  public getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.get<UserPromotionModel[]>(`/api/admin/promotion/user/${this.userId}/list`).subscribe({
      next: r => {
        this.items = r.map(x => this.createFormGroup(x));
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }


  public savePromotion(item: FormGroup) {
    this.isBusy = true;
    this.mApiService.post(`/api/admin/promotion/user/${this.userId}`, item.value).subscribe({
      next: r => {
        this.isBusy = false;
        this.mMessageService.addMessage({ text: 'Акция сохранена', type: this.mMessageService.types.success });
      },
      error: () => this.isBusy = false
    })
  }

  public removePromotion(item: FormGroup) {
    if (!confirm('Удалить акцию?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/promotion/user/${item.get('id')!.value}`).subscribe({
      next: r => {
        this.isBusy = false;
        this.getData(this.page);
        this.mMessageService.addMessage({ text: 'Акция удалена', type: this.mMessageService.types.success });
      },
      error: () => this.isBusy = false
    })
  }

  public selectFile(item: FormGroup, event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    this.isBusy = true;

    this.mApiService.formData<{ url: string }>('/api/admin/promotion/image/save', formData).subscribe({
      next: (r) => {
        item.controls['image'].setValue(r.url);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public getNewPromoImageStyle() {
    const image = this.newPromotionForm.controls['image'].value;
    if (image) {
      return {
        'background-image': `url(/${image})`
      };
    }
    return {}
  }


  private createFormGroup(promotion: UserPromotionModel) {
    return new FormGroup({
      id: new FormControl<string | undefined>(promotion.id),
      name: new FormControl<string | undefined>(promotion.name, Validators.required),
      image: new FormControl<string | undefined>(promotion.image, Validators.required),
      isEnabled: new FormControl<boolean>(promotion.isEnabled ?? false),
      startDateUTC: new FormControl<NgbTimeStruct | undefined>(parseTime(promotion.startDateUTC)),
      endDateUTC: new FormControl<NgbTimeStruct | undefined>(parseTime(promotion.endDateUTC)),
      promoCode: new FormControl<String>(promotion.promoCode!)
    });
  }
}